mod.modules.define("ResearchAnalytics", "BaseAnalytics", function(fn) {

	//fn.prototype.init = function(params) {
	//	this.category = "Research";
	//};

	//fn.prototype._getSectionName = function(section) {
	//	var sSectionName = "Unnamed Section";

	//	if (typeof (section) !== "string") {
	//		var dataSection = $(section).attr('data-section');
	//		sSectionName = (dataSection) ? dataSection : sSectionName;
	//	}

	//	return sSectionName;
	//};

	//fn.prototype.observables = {
	//	"section - changed": function(newSection) {
	//		if (newSection) {
	//			//this.trackPage(this._getSectionName(newSection));
	//		}
	//	},
	//	"module - removed": function(moduleClass) {
	//		if (moduleClass) {
	//			var moduleId = moduleClass.el.attr("data-widgetid");

	//			if (moduleId) {
	//				//this.trackAction("Apps", "Removed", moduleId);
	//			}
	//		}
	//	},
	//	"section - loaded": function (newSection) {
	//	    if (newSection) {
	//	        if (this._getSectionName(newSection) === 'company') {

	//	            //this.trackAction("View", "Symbol", $('#widget-com_securitybanner').data('context').Symbol);

	//	        }
	//	    }
	//    }
	//};

});